import './TermsOfService.css'
import { Helmet } from 'react-helmet';

const TermsOfService = () => {
    return (
        <div className="terms-of-service-container">
            <Helmet>
                <meta name="description" content='Servo offers the most convenient way to book local professionals for home improvement services like Pest Control, Window Cleaning, and Home Cleaning, in St. George, UT. Enjoy a pristine, well-maintained home with our reliable experts.' />
                <title>Servo - Learn About Terms Of Service</title>
            </Helmet>
            <div className="terms-of-service">
                    <h1>Servo Terms of Service</h1>
                    <section>
                        <h2>Welcome to Servo, LLC</h2>
                        <p>By accessing this Website, you are agreeing to be bound by these Website Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
                    </section>

                    <section>
                        <h2>Use License</h2>
                        <p>Permission is granted to temporarily download one copy of the materials (information or software) on Servo, LLC's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license, you may not:</p>
                        <ul>
                            <li>Modify or copy the materials;</li>
                            <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
                            <li>Attempt to decompile or reverse engineer any software contained on Servo, LLC's website;</li>
                            <li>Remove any copyright or other proprietary notations from the materials; or</li>
                            <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
                        </ul>
                        <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Servo, LLC at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p>
                    </section>

                    <section>
                        <h2>Disclaimer</h2>
                        <p>The materials on Servo, LLC's website are provided "as is". Servo, LLC makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                    </section>

                    <section>
                        <h2>Limitations</h2>
                        <p>In no event shall Servo, LLC or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption,) arising out of the use or inability to use the materials on Servo, LLC's Internet site, even if Servo, LLC or a Servo, LLC authorized representative has been notified orally or in writing of the possibility of such damage.</p>
                    </section>

                    <section>
                        <h2>Governing Law</h2>
                        <p>Any claim relating to Servo, LLC's website shall be governed by the laws of the State of Utah without regard to its conflict of law provisions.</p>
                    </section>

                    <section className="contact-info">
                        <h2>Contact Information</h2>
                        <p>If you have any questions about these Terms, please contact us at:</p>
                        <p>Email: spencer@bookservo.com</p>
                        <p>Phone: (971) 777-1845</p>
                    </section>
            </div>
        </div>
    )
}

export default TermsOfService;